import React from 'react'
import { useParams } from 'react-router-dom'
import styles from './GeoHeader.module.scss'
import Content from '../../../components/Content'

import Layout from '../../../components/Layout'
import GeoProvider from '../../../components/GeoProvider'
import DashboardMap from './DashboardMap'
import dataDisplayOptions from '../dataDisplayOptions'
import { startDate, endDate, displayDate } from '../dates'
import Header from './Header'
import MiddleCharts from './../MiddleChart'
import TrendChart from './TrendChart'
import GenderAgeView from '../Charts/GenderAgeView'
const AllergiesZip3Dashboard = () => {
  const { geo_parent, area, loc } = useParams()

  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
          <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={displayDate}
              locationName={loc}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected={'state'}
            >
              <Header headerType={geo_parent} headerNumber={2} geo_id={loc} />
              <DashboardMap
                geo_type={area}
                geo_id={loc}
                geo_parent={geo_parent}
                zoomLocation={loc}
              />
              <TrendChart geo_type={area} geo_id={loc} data_type="ALLERGIES" />
              <MiddleCharts geo_type={area} geo_id={loc} data_type="ALLERGIES" />
              <GenderAgeView 
              data_type="ALLERGIES" 
              geo_type={area}
              geo_id={loc} 
              searchLocation={'nat'} 
              searchLocationText={'nat'}/>

            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default AllergiesZip3Dashboard
